import { render } from "./ForgotPasswordVerification.vue?vue&type=template&id=4b62b3cc"
import script from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
script.render = render

export default script